import React, { useEffect, useState } from "react";
import commonStyles from "../../containers/settings/settingsEditCommon.css";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { SubtitleDescription } from "../settings/subtitleDescription";
import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import { logger } from "@fidget/common/utils";
import { useStore } from "../../models";
import { CloserLoaderComponent } from "@fidget/common/components/loader/closerLoader";
import { useAgentServices } from "../../models/agentServices";

export const AiGeneralSettings = () => {
  const { spinnerService } = useAgentServices();
  const { uiStore, intentStore } = useStore();
  const [sugestionsEnabled, setSugestionsEnabled] = useState<boolean>();

  useEffect(() => {
    spinnerService
      .areAISuggestionsEnabled()
      .then((result) => setSugestionsEnabled(result.enabled))
      .catch((err) => {
        logger.error({ message: "Couldn't check suggestions enabled", error: err });
        uiStore.addGenericErrorToast();
      });
  }, []);

  const onDisplaySuggestionsChecked = (value: boolean) => {
    spinnerService
      .setAISuggestionsEnabled(value)
      .then(() => {
        setSugestionsEnabled(value);
        intentStore.setSuggestionsEnabled(value);
      })
      .catch((err) => {
        logger.error({ message: "Couldn't save ai suggestions enabled", error: err });
        uiStore.addGenericErrorToast();
      });
  };

  const renderSuggestionsEnabledSection = (checked: boolean) => (
    <div className={commonStyles.section}>
      <SubtitleDescription
        subtitle={intl.formatMessage("ai.general.activate")}
        description={intl.formatMessage("ai.general.activate.description")}
      />
      <div className={commonStyles.content}>
        <CheckboxInput
          value={checked}
          id="typing_preview_enable"
          label={intl.formatMessage("ai.general.activate.checkbox")}
          onChange={onDisplaySuggestionsChecked}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className={commonStyles.title}>
        <L10n id="ai.navigation.generalSettings" />
      </div>
      {sugestionsEnabled !== undefined ? (
        renderSuggestionsEnabledSection(sugestionsEnabled)
      ) : (
        <CloserLoaderComponent />
      )}
    </>
  );
};
